var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5333 4.6582C13.8457 4.52803 14.2102 4.50898 14.5492 4.63609L18.6347 6.16962C19.1595 6.37146 19.5177 6.87469 19.5177 7.45167V17.7903C19.5177 18.8156 18.4337 19.4622 17.5343 19.0126L14.0859 17.2855L10.6334 19.2591C10.2335 19.4915 9.7497 19.5033 9.34094 19.2991L5.27384 17.2685C4.78889 17.0354 4.51168 16.5459 4.51168 16.0428V6.27175C4.50398 6.22761 4.5 6.18246 4.5 6.1367C4.5 5.19153 5.44653 4.50788 6.35198 4.85324L9.93811 6.19732L13.5333 4.6582ZM10.4786 7.6737L14.0515 6.1441V15.5376C13.8937 15.6086 13.6817 15.7162 13.396 15.8715L9.9604 17.8355V7.83125C10.0742 7.80387 10.2372 7.75417 10.4786 7.6737Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidMap);
export default __webpack_public_path__ + "static/media/solid-map.b577b6d9814784f80117bcb4a1384c03.svg";
export { ForwardRef as ReactComponent };